export const styles = {
  switchFormGroup: { display: "flex", flexDirection: "row", mt: 2 },
  basecard: {
    padding: 1,
    minHeight: "calc(100vh - 290px)",
    display: "flex",
    flexDirection: "column",
  },
}
